import { getInstallationsAttachedToCompany } from '../api/installation.api'
import { Installation } from '../models/installation.model'
import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'
import { usePortalQuery } from 'src/Libs/api'

type DataReturnType = [Installation[], boolean, boolean]

/**
 * Hook to query attached installations by company id
 */
export const useInstallationsAttachedToCompany = (companyId: string | undefined | null): DataReturnType => {
  const authFetch = useAuthFetchWithResponse()

  const getInstallationsAttachedToCompanyQueryFn = async (): Promise<Installation[] | null> => {
    const { error, hasErrors, value } = await getInstallationsAttachedToCompany(companyId as string, authFetch)

    if (hasErrors) {
      throw error || new Error('An unexpected error occurred when fetching installations attached to company')
    }

    return value
  }

  const { data, isLoading, isError } = usePortalQuery({
    queryKey: ['installations', `accountLinkFilter=accountId=${companyId},accountType=company`],
    queryFn: getInstallationsAttachedToCompanyQueryFn,
    enabled: !!companyId,
  })

  return [data || [], isLoading, isError]
}
